import React from "react";
import { Card, Form, Button, Row, Col } from "react-bootstrap";
import Table from "../../Components/UI/Table/Table"; 
import { IReduxState } from "../../utils/types";
import { useSelector } from "react-redux";

import CsvDownloader from "react-csv-downloader";

interface Props {
    usageReportData: any, 
}
const ListComponent =  ({ usageReportData }: Props)=>{  
  const adminData = useSelector((state: IReduxState) => state.Admin );
  
  let userList:any = adminData?.userList;  
  
  usageReportData && usageReportData.length>0 &&  usageReportData.map((x:any,i:any)=>{
        let statisticsArr = x?.type; 
        let demoIndex = statisticsArr.findIndex((item:any) => item.product === "demo");
        let cjscIndex = statisticsArr.findIndex((item:any) => item.product === "cjsc");
        let prodIndex = statisticsArr.findIndex((item:any) => item.product === "prod");
        x.demo_ip_fitering_count = 0;
        x.cjsc_count = 0;
        x.prod_ip_fitering_count = 0;
        if(demoIndex>=0){
          x.demo_ip_fitering_count = statisticsArr[demoIndex]?.count;
        }
        if(cjscIndex>=0){
          x.cjsc_count = statisticsArr[cjscIndex]?.count;
        }
        if(prodIndex>=0){
          x.prod_ip_fitering_count = statisticsArr[prodIndex]?.count;
        }  
        let userIndex = userList.findIndex((user:any) => user._id === x._id);
        if(userIndex>=0){ 
          x.user = userList[userIndex]?.name ? userList[userIndex]?.name : x._id;
        }else{
          x.user = x._id;
        }
        x.email = userList[userIndex]?.email ? userList[userIndex]?.email :x._id;
        return x;
    }); 

    let columns = [
        {
            Header: "User",
            accessor: "user",
            minWidth: 100,
        },
        {
          Header: "E-Mail",
          accessor: "email",
          minWidth: 100,
      },
        {
            Header: "Campaigns",
            accessor: "cjsc_count",
            minWidth: 100,
            Cell: ({ row }: any) =>
            `${row.original?.cjsc_count}`,
        },
        {
            Header: "Demo IP Filtering",
            accessor: "demo_ip_fitering_count",
            minWidth: 100,
            Cell: ({ row }: any) =>
            `${row.original?.demo_ip_fitering_count}`,
        },
        {
            Header: "Prod IP Filtering",
            accessor: "prod_ip_fitering_count",
            minWidth: 100,
            Cell: ({ row }: any) =>
            `${row.original?.prod_ip_fitering_count}`,
        }
    ];
    const sizePerPageList = [
        {
          text: "5",
          value: 5,
        },
        {
          text: "10",
          value: 10,
        },
        {
          text: "20",
          value: 20,
        },
        {
          text: "50",
          value: 50,
        },
    ]; 

    let newColumns = columns.map((column: any) => ({
      id: column.accessor,
      displayName: column.Header,
    }));
    
    
    return (
      <>
      <Row style={{ marginTop: "10px"}}>
        <Col style={{ textAlign: "right" }}>
      <CsvDownloader
              datas={usageReportData}
              columns={newColumns}
              text="Export to CSV"
              filename={`userdata_` + new Date().toLocaleString()}
              extension=".csv"
              className="btn btn-primary"
              style={{ marginRight: "0", fontWeight: "700" }}
              
            />
            </Col>
            </Row>
         <Table
          columns={columns}
          data={usageReportData}
          pageSize={10}
          sizePerPageList={sizePerPageList}
          isSortable={false}
          pagination={true}
          isSearchable={false}
        />
      </>
    );
}
export default ListComponent;